import { SkeletonElement } from "@/components/Skeleton";
import useDashboardSubtitle from "../_hooks/useDashboardSubtitle";

export default function DashboardSubtitle() {
  const { subtitle, loading } = useDashboardSubtitle();

  if (loading || !subtitle) {
    return (
      <div
        className="mt-2"
        role="status"
        aria-busy="true"
        aria-label="Loading dashboard summary"
        data-testid="dashboard-subtitle-skeleton"
      >
        <SkeletonElement height="h-5" width="w-full" className="max-w-xl lg:h-6" />
      </div>
    );
  }

  return <p className="mt-2 text-body-medium text-sys-brand-on-surface-variant lg:text-body-large">{subtitle}</p>;
}
